import { CategoryFeedTile } from "@app/home/components/social-feed/CategoryFeedTile";
import type { GradeCategory } from "@core/grades/types";
import { URLS } from "@core/shared/utils";
import { trans } from "@mongez/localization";
import { Link } from "@remix-run/react";
import { ArrowLeft, BookMarked } from "lucide-react";

export function ModernHomeCategories({
  categories = [],
  compact = false,
}: {
  categories?: GradeCategory[];
  compact?: boolean;
}) {
  if (categories.length === 0) return null;

  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-7">
      <div className="mb-4 flex items-end justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300">
            <BookMarked className="h-5 w-5" />
          </span>
          <div>
            <h2 className="text-lg font-black text-slate-950 dark:text-white">
              {trans("home.exploreTopics")}
            </h2>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              {trans("home.exploreTopicsDescription")}
            </p>
          </div>
        </div>
        <Link
          to={URLS.grades.categories}
          className="inline-flex shrink-0 items-center gap-1 text-xs font-black text-amber-700 dark:text-amber-300"
        >
          {trans("home.viewAllCategories")}
          <ArrowLeft className="h-4 w-4 ltr:rotate-180 rtl:rotate-0" />
        </Link>
      </div>
      <div
        className={
          compact
            ? "grid gap-3 lg:grid-cols-1"
            : "grid gap-4 sm:grid-cols-2 xl:grid-cols-3"
        }
      >
        {categories.slice(0, 6).map((category, index) => (
          <CategoryFeedTile
            key={category.id}
            category={category}
            index={index}
          />
        ))}
      </div>
    </section>
  );
}
